import { Component, MouseEvent, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { Theme } from '@mui/material';
import { WithStyles, createStyles, withStyles } from '@mui/styles';

const styles = (theme: Theme) =>
    createStyles({
        menuSubheader: {
            fontFamily: theme.typography.fontFamily,
            fontSize: '13px',
            opacity: 0.4,
            padding: 16,
            fontWeight: 'bold',
            textTransform: 'uppercase',
        },
    });

interface PoolMenuHeaderProps extends WithStyles<typeof styles> {
    title: ReactNode | string;
    className?: string;
}

export const PoolMenuHeader = withStyles(styles)(
    class PoolMenuHeaderBase extends Component<PoolMenuHeaderProps> {
        private handleClick = (event: MouseEvent<HTMLElement>) => {
            event.stopPropagation();
        };

        public override render() {
            const { title, classes } = this.props;

            return (
                <div className={`${classes.menuSubheader} ${this.props.className ?? ''}`} onClick={this.handleClick}>
                    {typeof title === 'string' ? <FormattedMessage id={title} /> : title}
                </div>
            );
        }
    }
);
